
const debugValue = (value) => {
  return JSON.stringify(value, null, 4)
}

export default debugValue



// WEBPACK FOOTER //
// ./src/filters/debugValue.js